var scope_0 = require('/drone/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cee4ec2db9ae223d2416f5177127dc3c.js').default;
var scope_1 = require('/drone/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_2 = require('/drone/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f6220fe89871c9b2e59e65230fa29b78.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    